import React, {Component} from 'react';
import axios from 'axios';
import {Label,Menu, Message, Form, Table, Tab} from 'semantic-ui-react';
import {Breadcrumb,Divider,Progress, Input, Step, Header,Modal,Dimmer, Loader, Grid, Segment, Item, Image, Popup, Button, Icon, Card} from 'semantic-ui-react';
import {withTranslation} from 'react-i18next';
import {Link,Redirect} from 'react-router-dom';

class Tools extends Component {
    constructor() {
        super(...arguments);
      this.state = {
        redirect:false
      }
    }

    componentDidMount() {
      window.scrollTo(0, 0);
    }

  redirect(url){

    if(url.indexOf("http")!=-1){
      window.location.href = url;
      return
    }

    this.setState({redirect:url})
  }

    render() {

    if(this.state.redirect){
      return <Redirect to={this.state.redirect}/>
    }

    const { t, i18n } = this.props;

        return (
        <Grid.Row >
          <Header as='h2' color="blue">
            <Header.Content>{t("services.title.invites")}</Header.Content>
            <Header.Subheader>
              {t("services.p.invites")}
            </Header.Subheader>
          </Header>

          <Message id="m4" onClick={()=>{ this.redirect("/console/invite") } }  style={{boxShadow:"none"}} icon>
            <Icon color="blue" name="check alternate circle" />
            <Message.Content>
              <Message.Header>{t("services.title.share")}</Message.Header>
              {t("services.p.share_notes")}
            </Message.Content>
          </Message>

          <Message id="m4"   onClick={()=>{ this.redirect("/console/withdraws") } }  style={{boxShadow:"none"}} icon>
            <Icon.Group style={{marginRight:"25px"}} size="large">
              <Icon circular name='dollar sign' color="green" inverted />
            </Icon.Group>
            <Message.Content>
              <Message.Header>{t("services.title.withdraw")}</Message.Header>
              {t("services.p.withdraw_notes")}
            </Message.Content>
          </Message>

          <Message id="m4"   onClick={()=>{ this.redirect("/console/maker") } }  style={{boxShadow:"none"}} icon>
            <Icon.Group style={{marginRight:"25px"}} size="large">
              <Icon circular name='audio description' color="orange" inverted />
            </Icon.Group>
            <Message.Content>
              <Message.Header>{t("services.title.maker")}</Message.Header>
              {t("services.p.maker_notes")}
            </Message.Content>
          </Message>

          <Message id="m4"   onClick={()=>{ this.redirect("/console/income") } }  style={{boxShadow:"none"}} icon>
            <Icon color='pink' name="tasks alternate circle" />
            <Message.Content>
              <Message.Header>{t("services.title.income")}</Message.Header>
              {t("services.p.income_notes")}
            </Message.Content>
          </Message>

      </Grid.Row>);
    }
}

export default withTranslation()(Tools);
